export default {"src":"/_next/static/media/InfoIconNewWhite_16.f3870fb5.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};